"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nTextTranslationByClass = void 0;
var core_1 = require("@storyplay/core");
Object.defineProperty(exports, "i18nTextTranslationByClass", { enumerable: true, get: function () { return core_1.i18nTextTranslationByClass; } });
